import { Controller } from '@hotwired/stimulus';

const TRIGGER_VALUE = 'themselves';

export default class extends Controller {
  static targets = [
    'relation',
    'requesterLastName',
    'requesterFirstName',
    'requesterLastNameKana',
    'requesterFirstNameKana',
    'clientLastName',
    'clientFirstName',
    'clientLastNameKana',
    'clientFirstNameKana',
  ];

  copyName() {
    if (this.relationTarget.value !== TRIGGER_VALUE) return;

    this.clientLastNameTarget.value = this.requesterLastNameTarget.value;
    this.clientFirstNameTarget.value = this.requesterFirstNameTarget.value;
    this.clientLastNameKanaTarget.value = this.requesterLastNameKanaTarget.value;
    this.clientFirstNameKanaTarget.value = this.requesterFirstNameKanaTarget.value;
  }
}
